import classNames from "classnames";
import {useEffect, useRef} from "react";
import {TZDate} from "react-day-picker";

import Button from "@/components/button/Button.tsx";
import {TZDateOrNow} from "@/components/datePicker/DatePicker.utils.ts";
import {DatePickerTimeSelectListProps} from "@/components/datePicker/subComponents/DatePickerTimeSelectList/DatePickerTimeSelectList.types.ts";
import {generateTimesAndState} from "@/components/datePicker/subComponents/DatePickerTimeSelectList/DatePickerTimeSelectList.utils.ts";

// This generates a list of time intervals based on the provided interval in minutes.
// The callback on the buttons returns a date object of the passed in date or the current date with the selected time set.
export const DatePickerTimeSelectList = ({
  intervalMinutes,
  timezone,
  onSelect,
  date,
  className,
  disabledAfter,
  disabledBefore,
}: DatePickerTimeSelectListProps) => {
  const baseDate = TZDateOrNow(date, timezone);
  const currentDate = TZDateOrNow(undefined, timezone);
  const activeDate = date ? new TZDate(date, timezone) : undefined;
  const times = generateTimesAndState(
    intervalMinutes,
    baseDate,
    timezone,
    currentDate,
    activeDate,
    disabledAfter,
    disabledBefore
  );

  const targetRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, []);

  return (
    <div className={"d-flex flex-column align-items-center gap-2"}>
      <div className={"pulseTextBodyBold d-flex justify-content-center p-1"}>Time</div>
      <div className={classNames(className, "d-flex flex-column gap-3")}>
        {times.map(({hour, minute, isCurrent, isActive, label, disabled, localDate}) => {
          return (
            <Button
              key={`${hour}:${minute}`}
              variant="datePicker"
              className={classNames({current: isCurrent && !isActive}, {active: isActive})}
              ref={isActive ? targetRef : null}
              onClick={() => onSelect(localDate)}
              disabled={disabled}
            >
              {label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
